import React from 'react';

import FilterWrapper from './FilterWrapper';
import FilterSkeleton from './FilterSkeleton';

const TabContent = ({
    filters = [],
    loading = false,
    data = {},
    selectedFilters,
    addSelectedFilter,
    removeSelectedFilter,
}) => {

    return filters.map((filter, filterIndex) => {

        if (loading) return <FilterSkeleton key={filter.filterName} />;

        return (
            <FilterWrapper
                key={filterIndex}
                contentId={`${filter.filterName}-${filterIndex}`}
                fieldsData={data.fields || []}
                filterConfig={filter}
                activeFilters={selectedFilters}
                addSelectedFilter={addSelectedFilter}
                removeSelectedFilter={removeSelectedFilter}
                data-index={filterIndex}
                data-name={filter.filterName}
            />
        );

    });

};

export default TabContent;
